<template>
  <div>
    <v-simple-table dense class="row-pointer">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('report.bdssf34.number') }}
            </th>
            <th class="text-left">
              {{ $t('label.description') }}
            </th>
            <th class="text-left">
              {{ $t('report.bdssf34.declared_status') }}
            </th>
            <th class="text-left">
              {{ $t('report.bdssf34.number_of_documents') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in requirements"
            :key="item.identifier"
            @click="handleRowClick(item)"
          >
            <td>{{ item.identifier }}</td>
            <td>{{ item.requirement_name }}</td>
            <td>{{ $langobj.parse(item.status_lang) }}</td>
            <td>{{ item.documents.length }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ReportRequirements",
  data() { return {
  }},

  props: {
    requirements: Array
  },

  components: {
  },

  computed: {
  },

  methods: {
    handleRowClick(item) {
      this.$router.push(
        { name: 'bdssf_report_requirement_detail', params:
          {
            service_provider_id: this.$route.params.service_provider_id,
            report_id: this.$route.params.report_id,
            requirement_id: item.requirement_id
          }
        }
      );
    },
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/collab.scss";
</style>